import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { useSelector } from "react-redux";
import { RootState } from "../../state";
import { IconButton, Typography, Box } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import SquareView from "../ItemView/SquareView";
import NotificationService from "../Notification/notificationService";
import PublicDataService from "../../services/publicDataService";

import { LastShirtItem } from "../../types/authTypes";
import { ShirtInterface } from "../../services/shirts/types";
import { User } from "../../entities/User";
import { Shirt } from "../../entities/Shirt";

const LastShirtsAdded = () => {
  const [items, setItems] = useState<Array<LastShirtItem> | undefined>(
    undefined
  );
  const [slideIndex, setSlideIndex] = useState<number>(0);

  let sliderRef = useRef<Slider | null>(null);

  const loginData = useSelector((state: RootState) => state.login) as {
    userId?: string;
  };

  const { lastShirts } = PublicDataService();
  const { error } = NotificationService();

  useEffect(() => {
    lastShirts(7).then((result) => {
      if (result) {
        const resultProcessed: Array<LastShirtItem> = result.map((shirt) => {
          const userData = new User(
            shirt.owner.id,
            undefined,
            shirt.owner.username,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            shirt.owner.profile_image,
            undefined,
            shirt.owner.userData,
            undefined,
            [],
            undefined
          );
          const shirtInterface: ShirtInterface = {
            id: shirt.id,
            title: shirt.title,
            description: shirt.description,
            purchase_date: shirt.purchase_date,
            purchase_price: shirt.purchase_price,
            certificate: shirt.certificate,
            is_private: shirt.is_private,
            condition: shirt.condition,
            model: shirt.model,
            signature: shirt.signature,
            properties: shirt.properties,
            mainImage: shirt.mainImage,
            owner: {
              id: shirt.owner.id,
              avatar: shirt.owner.profile_image?.url ?? "",
              username: shirt.owner.username,
            },
            images: shirt.images,
            irresistible_offers: false,
            current_price: shirt.current_price,
          };
          const newShirt = new Shirt(shirtInterface);

          return { shirt: newShirt, user: userData };
        });
        setItems(resultProcessed);
      } else {
        error("Last shirts: something went wrong");
      }
    });
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(slideIndex);
    }
  }, [slideIndex]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          width: "100%",
          padding: "10px 0px",
          borderTop: "1px solid #eee",
          borderBottom: "1px solid #eee",
        }}
      >
        <Box sx={{ width: { xs: "70%", md: "fit-content" } }}>
          <Typography
            variant="communitySectionTitle"
            sx={{ fontStyle: "italic" }}
          >
            New shirts in collections
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            width: { xs: "30%", md: "fit-content" },
            columnGap: 1,
          }}
        >
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              marginRight: "1rem",
            }}
          >
            <Link
              to={loginData?.userId ? "/my-profile" : "/sign-up"}
              style={{ display: "flex" }}
            >
              <a className="default-btn move-right">
                <span style={{ fontStyle: "italic" }}>+ create collection</span>
              </a>
            </Link>
          </Box>
          <Box>
            <IconButton
              size="small"
              sx={{
                color: "white",
                backgroundColor: "#3c3c40",
                fontWeight: "700 !important",
                fontSize: "1rem",
              }}
              onClick={() => {
                slideIndex > 0 && setSlideIndex((slideIndex) => slideIndex - 1);
              }}
            >
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              size="small"
              sx={{
                color: "white",
                backgroundColor: "#3c3c40",
                fontWeight: "700 !important",
                fontSize: "1rem",
              }}
              onClick={() => {
                items &&
                  slideIndex < items.length &&
                  setSlideIndex((slideIndex) => slideIndex + 1);
              }}
            >
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          paddingTop: { xs: "1rem", sm: "2rem" },
        }}
        aria-label="Slider-Box"
      >
        {items && items?.length > 0 && (
          <Slider
            ref={(slider) => {
              if (slider) sliderRef.current = slider;
            }}
            infinite={false}
            slidesToShow={4}
            slidesToScroll={1}
            initialSlide={0}
            arrows={false}
            dots={false}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  initialSlide: 2,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {items?.map((element, key) => (
              <Box key={key}>
                <Box
                  sx={{
                    marginX: "0.8rem",
                  }}
                >
                  <SquareView
                    shirt={element.shirt}
                    imgHeight={70}
                    shouldShowUser={true}
                  />
                </Box>
              </Box>
            ))}
          </Slider>
        )}
      </Box>

      <Box
        sx={{
          display: { xs: "block", sm: "none" },
          textAlign: "center",
          marginTop: "1rem",
        }}
      >
        <Link to={loginData?.userId ? "/my-profile" : "/sign-up"}>
          <a className="default-btn move-right">
            <span style={{ fontStyle: "italic" }}>+ create collection</span>
          </a>
        </Link>
      </Box>
    </>
  );
};

export default LastShirtsAdded;
